import { NavLink } from 'react-router-dom';
import {
  Activity,
  BarChart3,
  Building2,
  Database,
  GanttChart,
  KeyRound,
  Layers,
  LayoutDashboard,
  MessagesSquare,
  Moon,
  Settings as SettingsIcon,
  Sparkles,
  Users,
} from 'lucide-react';
import { cn } from '@/lib/cn';

const nav = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Overview' },
  { to: '/agents', icon: Sparkles, label: 'Agents' },
  { to: '/organization', icon: Building2, label: 'Organization' },
  { to: '/sessions', icon: MessagesSquare, label: 'Sessions' },
  { to: '/activity', icon: Activity, label: 'Activity' },
  { to: '/skills', icon: Layers, label: 'Skills' },
  { to: '/rules', icon: KeyRound, label: 'Rules' },
  { to: '/proposals', icon: Moon, label: 'Proposals' },
  { to: '/scheduler', icon: GanttChart, label: 'Scheduler' },
  { to: '/usage', icon: BarChart3, label: 'Usage' },
  { to: '/system', icon: Database, label: 'System' },
  { to: '/users', icon: Users, label: 'Users' },
  { to: '/settings', icon: SettingsIcon, label: 'Settings' },
];

export function Sidebar() {
  return (
    <aside className="hidden w-56 shrink-0 flex-col border-r bg-card md:flex">
      <div className="flex h-14 items-center gap-2 border-b px-4 font-semibold">
        <div className="grid h-8 w-8 place-items-center rounded-md bg-primary/10 text-primary">
          <Sparkles className="h-4 w-4" />
        </div>
        <span>Command Room</span>
      </div>
      <nav className="flex flex-1 flex-col gap-0.5 p-2">
        {nav.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'group flex items-center gap-2.5 rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground',
                isActive && 'bg-accent font-medium text-accent-foreground',
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t p-3 text-xs text-muted-foreground">
        v0.1.0
      </div>
    </aside>
  );
}
